module.exports = __webpack_public_path__ + "app/components/users/new.view.html";